import { PERMISSION_LEAVE_OFF_ACCESS_PERSONAL } from 'constants/permissions';
import { PermissionType } from 'hrm-common/extensions/enums/personel';
import IconConfiguration from 'assets/icons/ic_menu_configuration.svg';
import IconDashboard from 'assets/icons/ic_menu_dashboard.svg';
import IconEmployee from 'assets/icons/ic_menu_employee.svg';
import IconEquipment from 'assets/icons/ic_menu_equipment.svg';
import IconInsurance from 'assets/icons/ic_menu_insurance.svg';
import IconLeaveOff from 'assets/icons/ic_menu_leaveoff_manager.svg';
import IconMyPage from 'assets/icons/ic_menu_mypage.svg';
import IconOnOffboard from 'assets/icons/ic_menu_onoffboard_manager.svg';
import IconTimesheet from 'assets/icons/ic_menu_timesheet_manager.svg';
import IconWatchingList from 'assets/icons/ic_menu_watchinglist.svg';
import IconProjectManager from 'assets/icons/ic_menu_project_manager.svg';
import IconOvertime from 'assets/icons/ic_menu_overtime.svg';
import IconXclaim from 'assets/icons/ic_x_claim.svg';

import DashboardModuleIcon from 'assets/icons/dashboardModuleIcon.png';
import ConfigurationModuleIcon from 'assets/icons/configurationModuleIcon.png';
import EmployeeModuleIcon from 'assets/icons/employeeModuleIcon.png';
import EquipmentModuleIcon from 'assets/icons/equipmentModuleIcon.png';
import InsuranceModuleIcon from 'assets/icons/insuranceModuleIcon.png';
import LeaveOffModuleIcon from 'assets/icons/leaveOffModuleIcon.png';
import MypageModuleIcon from 'assets/icons/mypageModuleIcon.png';
import TimesheetModuleIcon from 'assets/icons/timesheetModuleIcon.png';
import ContractModuleIcon from 'assets/icons/contractModuleIcon.png';
import TaxModuleIcon from 'assets/icons/taxModuleIcon.png';
import TrainingModuleIcon from 'assets/icons/trainingModuleIcon.png';
import PerformanceModuleIcon from 'assets/icons/performanceModuleIcon.png';
import OvertimeModuleIcon from 'assets/icons/overtimeModuleIcon.png';
import PolicyModuleIcon from 'assets/icons/policyModuleIcon.png';

export const LIST_PATH_PERMISSION = [
  {
    path: '/dashboard',
    permission: [PermissionType.DASHBOARD_ACCESS_HR],
  },
  {
    path: '/report',
    permission: [PermissionType.DASHBOARD_ACCESS_HR],
  },
  {
    path: '/my-page/timesheet',
    permission: [PermissionType.TIMESHEET_ACCESS_PERSONAL],
  },
  {
    path: '/my-page/payslip',
    permission: [PermissionType.TIMESHEET_ACCESS_PERSONAL],
  },
  {
    path: '/my-page/timekeeping',
    permission: [PermissionType.TIMEKEEPING_ACCESS_PERSONAL],
  },
  {
    path: '/my-page/performance-review',
    permission: ['PERFORMANCE_ACCESS_PERSONAL'],
  },
  //CHUA CO
  {
    path: '/my-page/leave-off',
    permission: [PERMISSION_LEAVE_OFF_ACCESS_PERSONAL],
  },
  {
    path: '/my-page/on-off/onboard',
    permission: [PermissionType.ONBOARD_ACCESS_PERSONNEL],
  },
  {
    path: '/my-page/on-off/offboard',
    permission: [PermissionType.OFFBOARD_ACCESS_PERSONNEL],
  },
  {
    path: '/my-page/observation_list',
    permission: [PermissionType.TIMESHEET_ACCESS_OBSERVATION_LIST],
  },
  {
    path: '/employee',
    permission: [
      PermissionType.PERSONNEL_MANAGE,
      PermissionType.PERSONNEL_RECORD_REQUEST_APPROVAL,
      PermissionType.PERSONNEL_RECORD_APPROVAL,
      PermissionType.PERSONNEL_RECORD_ACTIVE_DEACTIVE,
    ],
  },
  //watching list co th dac biet, cha co permission, con ko co
  {
    path: '/manage-watching-list/watching-list',
    permission: [PermissionType.WATCHINGLIST_VIEW],
  },
  {
    path: '/manage-watching-list/manager-request-list',
    permission: [PermissionType.WATCHINGLIST_MANAGER_REQUEST_LIST_VIEW],
  },
  {
    path: '/manage-watching-list/hr-request-list',
    permission: [PermissionType.WATCHINGLIST_HR_REQUEST_LIST_VIEW],
  },
  {
    path: '/manage/request_approval',
    permission: [PermissionType.TIMESHEET_REQUEST_APPROVAL],
  },
  {
    path: '/manage/request_pending',
    permission: [PermissionType.TIMESHEET_REQUEST_APPROVAL],
  },
  {
    path: '/manage/timesheet_approval',
    permission: [PermissionType.TIMESHEET_MONTH_APPROVAL],
  },
  {
    path: '/manage/employee_timesheet',
    permission: [PermissionType.TIMESHEET_MANAGE_EMPLOYEE, PermissionType.TIMESHEET_VIEW_EMPLOYEE],
  },
  {
    path: '/onboard-offboard/employee-onboard',
    permission: [PermissionType.ONBOARD_MANAGE_EMPLOYEE],
  },
  {
    path: '/onboard-offboard/employee-offboard',
    permission: [PermissionType.OFFBOARD_MANAGE_EMPLOYEE],
  },
  {
    path: '/manage-leave-off',
    permission: [PermissionType.LEAVE_OFF_MANAGE_ACCESS],
  },
  {
    path: '/manage-project',
    permission: [PermissionType.PERSONNEL_MANAGE],
  },
  {
    path: '/history-manage-project',
    permission: [PermissionType.PERSONNEL_MANAGE],
  },
  //Thieu permission cha cua overtime kiem tra ben MenuListManager
  {
    path: '/manage-overtime/overtime-plan-request',
    permission: [],
  },
  {
    path: '/manage-overtime/history-overtime-plan-request',
    permission: [],
  },
  {
    path: '/manage-overtime/overtime-approval',
    permission: [PermissionType.PERSONNEL_MANAGE],
  },
  {
    path: '/manage-overtime/history-overtime-approval',
    permission: [PermissionType.PERSONNEL_MANAGE],
  },
  {
    path: '/manage-overtime/manage-overtime-type',
    permission: [PermissionType.PERSONNEL_MANAGE],
  },
  {
    path: '/manage-overtime/compensatory-configuration',
    permission: [PermissionType.PERSONNEL_MANAGE],
  },
  //Equipment
  {
    path: '/equipment/inventory-control',
    permission: [PermissionType.DEVICE_INVENTORY],
  },
  {
    path: '/equipment/equipment-handover',
    permission: [PermissionType.DEVICE_MANAGE],
  },
  //Insurance
  //Permission thang cha co thang con ko co
  {
    path: '/insurance/complusory-insurance',
    permission: [
      PermissionType.SCHEDULE_INCREASE_DECREASE_LIST,
      PermissionType.INSURANCE_APPROVAL_LIST_VIEW,
      PermissionType.INSURANCE_PARTICIPANTS_LIST_VIEW,
      PermissionType.RECORD_INSURANCE_PAYMENT_VIEW,
    ],
  },
  {
    path: '/insurance/setting-insurance',
    permission: [PermissionType.COMPULSORY_INSURANCE_SETTING_VIEW],
  },
  //Payroll
  {
    path: '/payroll/overall',
    permission: [PermissionType.VIEW_EMPLOYEE_PAYROLL_INFO],
  },
  {
    path: '/payroll/view-employee',
    permission: [PermissionType.VIEW_EMPLOYEE_PAYROLL_INFO],
  },
  {
    path: '/payroll/pay-runs',
    permission: [PermissionType.VIEW_PAYRUNS_INFO],
  },
  {
    path: '/payroll/dashboard',
    permission: [PermissionType.VIEW_EMPLOYEE_PAYROLL_INFO],
  },
  //Configuration
  {
    path: '/configuration/category',
    permission: [PermissionType.CATEGORY_MANAGE],
  },
  {
    path: '/configuration/department',
    permission: [PermissionType.DEPARTMENT_MANAGE],
  },
  {
    path: '/configuration/position',
    permission: [PermissionType.POSITION_MANAGE],
  },
  {
    path: '/configuration/role',
    permission: [PermissionType.PERMISSION_MANAGE],
  },
  {
    path: '/configuration/workshift',
    permission: [PermissionType.WORKSHIFT_MANAGE],
  },
  {
    path: '/configuration/payroll',
    permission: [PermissionType.SETUP_PAYROLL],
  },
  {
    path: '/configuration/tax-management',
    permission: [PermissionType.SETUP_PAYROLL],
  },
  {
    path: '/configuration/status',
    permission: [PermissionType.SETUP_WORKFLOW],
  },
  {
    path: '/configuration/action',
    permission: [PermissionType.SETUP_WORKFLOW],
  },
  {
    path: '/configuration/workflow-type',
    permission: [PermissionType.SETUP_WORKFLOW],
  },

  {
    path: '/configuration/setup-policy',
    permission: [PermissionType.PERMISSION_MANAGE],
  },
  {
    path: '/configuration/setup-workflow',
    permission: [
      PermissionType.ONBOARD_MANAGE_PROCESS,
      PermissionType.ONBOARD_MANAGE_TASK,
      PermissionType.ONBOARD_EVALUATE,
    ],
  },
  {
    path: '/configuration/menu-screen',
    permission: [
      PermissionType.ONBOARD_MANAGE_PROCESS,
      PermissionType.ONBOARD_MANAGE_TASK,
      PermissionType.ONBOARD_EVALUATE,
    ],
  },
  {
    path: '/configuration/performance-review',
    permission: [
      PermissionType.ONBOARD_MANAGE_PROCESS,
      PermissionType.ONBOARD_MANAGE_TASK,
      PermissionType.ONBOARD_EVALUATE,
      PermissionType.PERFORMANCE_MANAGE,
    ],
  },
  {
    path: '/configuration/goals',
    permission: [
      PermissionType.ONBOARD_MANAGE_PROCESS,
      PermissionType.ONBOARD_MANAGE_TASK,
      PermissionType.ONBOARD_EVALUATE,
      PermissionType.SETUP_GOAL,
    ],
  },
  {
    path: '/configuration/recruitment',
    permission: [
      PermissionType.ONBOARD_MANAGE_PROCESS,
      PermissionType.ONBOARD_MANAGE_TASK,
      PermissionType.ONBOARD_EVALUATE,
      PermissionType.PERFORMANCE_MANAGE,
    ],
  },
  {
    path: '/configuration/manage-mail-&-notification/manage-mail-templates',
    permission: [PermissionType.EMAIL_TEMPLATE_MANAGE],
  },
  {
    path: '/configuration/manage-mail-&-notification/auto-send-mail',
    permission: [PermissionType.EMAIL_TEMPLATE_MANAGE],
  },
  {
    path: '/configuration/manage-mail-&-notification/config-notification',
    permission: [PermissionType.EMAIL_TEMPLATE_MANAGE],
  },
  {
    path: '/configuration/manage-mail-&-notification/group-email',
    permission: [PermissionType.EMAIL_TEMPLATE_MANAGE],
  },
  //General
  {
    path: '/configuration/general-setting',
    permission: [PermissionType.GENERAL_MANAGE],
  },
  {
    path: '/recruitment',
    permission: [PermissionType.TIMESHEET_ACCESS_PERSONAL],
  },
];

export const LIST_ICON = [
  { id: '1', icon: IconConfiguration, moduleIcon: ConfigurationModuleIcon },
  { id: '2', icon: IconDashboard, moduleIcon: DashboardModuleIcon },
  { id: '3', icon: IconEmployee, moduleIcon: EmployeeModuleIcon },
  { id: '4', icon: IconEquipment, moduleIcon: ContractModuleIcon },
  { id: '5', icon: IconInsurance, moduleIcon: InsuranceModuleIcon },
  { id: '6', icon: IconLeaveOff, moduleIcon: LeaveOffModuleIcon },
  { id: '7', icon: IconMyPage, moduleIcon: MypageModuleIcon },
  { id: '8', icon: IconOnOffboard, moduleIcon: TaxModuleIcon },
  { id: '9', icon: IconTimesheet, moduleIcon: TimesheetModuleIcon },
  { id: '10', icon: IconWatchingList, moduleIcon: PolicyModuleIcon },
  { id: '11', icon: IconProjectManager, moduleIcon: PerformanceModuleIcon },
  { id: '12', icon: IconOvertime, moduleIcon: OvertimeModuleIcon },
  { id: '13', icon: IconXclaim },
];
